<template>
  <div>
    <div v-if="tgChannels.length === 0" class="text-center p-4">
      <p class="text-muted">Пусто</p>
    </div>

    <table v-else class="table">
      <thead>
      <tr>
        <th scope="col">ID</th>
        <th scope="col">Проект</th>
        <th scope="col">Действие</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(row, index) in tgChannels" :key="index">
        <th scope="row">{{ row.id }}</th>
        <td>{{ row.name }}</td>
        <td>
          <router-link :to="{name: 'tg_channel', params: { id: row.id }}">Перейти</router-link>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import {computed} from "vue";
import {useTgChannelsStore} from '@/store/tg-channels'

const tgChannelsStore = useTgChannelsStore()

// server list
const tgChannels = computed(() => tgChannelsStore.items)
tgChannelsStore.getList()
</script>